// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";

const availableBranchesServiceUrl = "api/ces/availableWarehouses";

export type Branch = {
    id?: string;
    name?: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
};
export type AvailableBranchesDataModel = Branch[];

export function getAvailableBranches(): Promise<AvailableBranchesDataModel> {
    return get<AvailableBranchesDataModel>(availableBranchesServiceUrl);
}
